import { SectionsEditorState } from 'types/state';

export const createSectionsEditorState = (): SectionsEditorState => ({
  formValues: new Map(),
  submited: false,
  submitDidSucceed: false
});
